import { observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CardNumberSearchRequest {
  /**
   * First part of card number.
   */
  @observable
  firstPart?: string;

  /**
   * Second part of card number.
   */
  @observable
  secondPart?: string;
}

export const CardNumberSearchRequestValidationRules: EntityValidationRules<CardNumberSearchRequest> = {
  firstPart: {
    isLength: {
      max: 4,
      optional: true,
    },
  },
  secondPart: {
    isLength: {
      max: 6,
      optional: true,
    },
  },
};
